<template>
  <div>
    <!-- <ValidationProvider :name="$t(itemName)" rules="required" v-slot="{ errors }"> -->
    <v-autocomplete
      v-model="editedItem"
      :items="allItem"
      :search-input.sync="searchInput"
      :item-text="setItemText"
      item-value="Id"
      required
      return-object
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_results')"
      @change="chooseItem"
      :ref="refName"
      @keyup.enter="keyupEnter"
    >
      <!-- :error-messages="errors[0]" -->
      <template v-slot:append-item>
        <div v-intersect="isScrollBarBottom" />
      </template>
      <template v-slot:item="data">
        <template>
          <v-list-item-content>
            <v-list-item-title
              >{{ data.item.Name }}
              <v-icon v-if="data.item.IsExistResume" color="green">mdi-check</v-icon>
              <v-icon v-else color="red">mdi-close</v-icon>
            </v-list-item-title>
            <v-list-item-subtitle>{{ data.item.Number }}</v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
      <template v-slot:selection="{ item }">
        {{ setSelectText(item) }}
      </template>
      <template v-slot:label>
        <span class="red--text">
          <strong>* </strong>
        </span>
        {{ $t(itemName) }}
      </template>
    </v-autocomplete>
    <!-- </ValidationProvider> -->
  </div>
</template>

<script>
import { HttpItem } from '@/js/http-Manager'
export default {
  name: 'ItemAutocompleteForEg',
  props: {
    fatherEditedItem: {
      type: Object
    },
    editedItemIndex: {
      type: Number
    },
    itemName: {
      type: String
    },
    refName: {
      type: String
    },
    licensePlate: {
      type: String
    },
    customerDeviceType: {
      type: Number
    }
  },
  components: {},
  data: () => ({
    allItem: [],
    searchInput: null,
    page: 1,
    perPage: 10,
    tempWatchItem: '',
    searchCount: 0,
    isLoadingItem: false,
    getIntersectingObj: null,
    editedItem: {
      Id: '',
      Number: '',
      Name: ''
    },
    defaultItem: {
      Id: '',
      Number: '',
      Name: ''
    },
    isGetItemFinish: false
  }),
  async mounted () {
    await this.getItemsCount()
    await this.getItems()
    this.page = 0
  },
  watch: {
    async searchInput (val) {
      this.tempWatchItem = val
      this.page = 1
      this.allItem = []
      this.isGetItemFinish = true
      await this.getItemsCount()
      await this.getItems()
      this.isGetItemFinish = false
    },
    async getIntersectingObj (newVal, oldVal) {
      // 舊物件和新物件(getIntersectingObj) 相減  時間間隔太短不能觸發
      if (newVal && newVal.length > 0 && !this.isGetItemFinish) {
        let timeDiff = newVal[0].time - (oldVal ? oldVal[0].time : 0)
        if (timeDiff > 100) {
          this.page += 1
          await this.getItems()
        }
      }
    },
    async fatherEditedItem (val) {
      if (val.ItemId === '') {
        this.tempWatchItem = ''
        this.page = 1
        this.allItem = []
        this.isGetItemFinish = true
        await this.getItemsCount()
        await this.getItems()
        this.isGetItemFinish = false
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem))
      } else {
        this.editedItem.Id = val.ItemId
        this.editedItem.Number = val.Number
        this.editedItem.Name = val.Name
        this.editedItem.Unit = val.Unit
        this.editedItem.Price = val.Price
        this.editedItem.IsMonthItem = val.IsMonthItem
        this.editedItem.IsDelete = val.IsDelete
        this.editedItem.StoreNo = val.StoreNo
        this.editedItem.RepairPrice = val.RepairPrice
        this.editedItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
        this.editedItem.RentWarrantyPeriod = val.RentWarrantyPeriod
        this.editedItem.WarrantyPeriod = val.WarrantyPeriod
        this.editedItem.HasSerialNumber = val.HasSerialNumber
        this.editedItem.IsExistResume = val.IsExistResume
        this.editedItem.IsOutOfWarranty = val.IsOutOfWarranty
        this.editedItem.Type = val.Type
        this.editedItem.BomId = val.BomId
        this.editedItem.BomName = val.BomName
        this.editedItem.BomDescribe = val.BomDescribe
        this.editedItem.BuyOrRentType = val.BuyOrRentType
        this.editedItem = JSON.parse(JSON.stringify(this.editedItem))
      }
    },
    async customerDeviceType (oldVal, newVal) {
      if (
        ((oldVal === 0 || oldVal === 3) && (newVal === 1 || newVal === 2)) ||
        ((oldVal === 1 || oldVal === 2) && (newVal === 0 || newVal === 3))
      ) {
        this.tempWatchItem = this.editedItem && this.editedItem.Number ? this.editedItem.Number : ''
        this.page = 1
        this.allItem = []
        this.isGetItemFinish = true
        await this.getItemsCount()
        await this.getItems()
        this.isGetItemFinish = false
        this.editedItem =
          this.editedItem && this.editedItem.Number
            ? JSON.parse(JSON.stringify(this.editedItem))
            : JSON.parse(JSON.stringify(this.defaultItem))
        this.$emit('setEditedItem', this.editedItem)
      }
    }
  },
  methods: {
    keyupEnter (event) {
      this.$refs[this.refName].isMenuActive = false
      this.$refs[this.refName].isFocused = false
      this.$emit('keyupEnter', event)
    },
    async chooseItem () {
      if (this.editedItem) {
        this.$emit('setEditedItem', this.editedItem)
      } else {
        this.$emit('setEditedItem', this.defaultItem)
      }
    },
    setSelectText (item) {
      return item.Name
    },
    setItemText (item) {
      return item.Number + ' - ' + item.Name
    },
    async getItemsCount () {
      let param = {
        searchItem: this.tempWatchItem,
        customerDeviceType: this.customerDeviceType ? this.customerDeviceType : null
      }
      let response = await HttpItem.GetAllItemCount(param)

      this.searchCount = response.status === 200 ? response.data.Data : 0
    },
    async getItems () {
      if (
        this.editedItemIndex === -1 &&
        this.searchCount > (this.page - 1) * this.perPage &&
        this.searchCount !== 0
      ) {
        this.isLoadingItem = true
        let param = {
          SearchItem: this.tempWatchItem,
          LicensePlate: this.licensePlate,
          Page: this.page,
          PerPage: this.perPage,
          CustomerDeviceType: this.customerDeviceType ? this.customerDeviceType : null
        }
        let response = await HttpItem.GetEgItemList(param)
        if (response.status === 200) {
          this.allItem = [...this.allItem, ...response.data.Data]
        } else {
          this.allItem = []
        }
        this.isLoadingItem = false
      }
    },
    async isScrollBarBottom (getIntersectingObj) {
      this.getIntersectingObj = getIntersectingObj
    }
  }
}
</script>
